<template>
  <div class="active_table" ref="content">
    <toolbar>
      <div class="search" style="width: 100%">
        <DatePicker
          type="daterange"
          placement="bottom-end"
          placeholder="选择日期"
          style="width: 200px; margin-left: 10px"
          @on-change="dateSelect($event)"
        ></DatePicker>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em"
          >搜索</i-button
        >
      </div>
    </toolbar>
    <div class="table">
      <v-chart
        autoresize
        :options="orgOptions"
        style="width: 60vw; height: 60vh"
      />
    </div>
  </div>
</template>
  
  <style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 100%;
}
.active_table {
  width: 100%;
  height: 100%;
  padding-top: 2em;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
</style>
  
  <script>
import toolbar from "../../../p_company/components/toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具

export default {
  data() {
    return {
      orgOptions: {},
      // 查询
      search: {
        startDate: null,
        endDate: null,
      },
    };
  },
  components: {
    toolbar,
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData() {
      // 获取数据
      this.$api.Warn.getVisitor({ content: this.search }, [null, "park"]).then((res) => {
        if (res.code == 0) {
          // 获取成功
          let warnData = res.data; //数据
          let dateList = []; // 标题
          let dataList = []; // 数据值
          warnData.map((res) => {
            dateList.push(res.date);
            dataList.push(res.count);
            //console.log(res.date);
          });

          this.orgOptions = {
            color: ["#3398DB"],
            tooltip: {
              trigger: "axis",
              formatter: "{b} <br/>访问人次:{c}",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            toolbox: {
              show: true,
              feature: {
                saveAsImage: {},
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                name: "企业",
                boundaryGap: true,
                axisLabel: {
                  //底部文字倾斜
                  interval: 0,
                  rotate: 25,
                },
                data: dateList,
              },
            ],
            yAxis: [
              {
                type: "value",
              },
            ],
            series: [
              {
                name: "访问人次",
                type: "bar",
                barWidth: "60%",
                data: dataList,
              },
            ],
          };
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
  },
};
</script>